<!-- 通过URL启动流程 -->
<template>
<div style="height: 100%">
  <div class="loadingContainer" v-if="loadingContainer.remind">
    <div class="loadingContainer_icon">
      <i class="el-icon-loading loadingContainer_icon_loading" v-if="loadingContainer.remind === '流程启动中...'" />
      <i class="el-icon-error loadingContainer_icon_error" v-else />
    </div>
    <div class="loadingContainer_remind">
      <p>{{loadingContainer.remind}}</p>
    </div>
  </div>
  <view-form v-else ref="viewForm" :viewFormData="viewFormData" @formClose="formClose">

  </view-form>
</div>
</template>

<script>

import viewForm from '@/workFlow/formComponent/viewForm/ViewForm.vue'

import { HandleForm } from '@/workFlow/utils/flowUtils'
export default {
  data() {
    return {
      // 加载容器控制器
      loadingContainer: {
        remind: '流程启动中...'
      },
      // view-form 组件依赖数据
      viewFormData: {
        // 流程状态详情
        ProcessState: 'justStart',
        // 操作类型
        pageKey: 'DO',
        // 表单的数据
        modelData: {},
        // 表单的配置
        options: {},
        keyInfo: {},
        // 会签控制
        sign: {
          // 是否会签模式
          isSign: false,
          // 会签数据
          signData: {}
        }
      }
    }
  },
  components: {
    viewForm
  },
  methods: {
    forceUpdate() {
      try {
        this.$refs.viewForm.$refs.avueform.$forceUpdate()
      } catch (error) {
        console.error(error)
      }
    }
  },
  created() {
    let queryData = this.deepClone(this.$route.query) || {}
    let {
      businessKey,
      processDefinitionKey
    } = queryData
    if (!processDefinitionKey) {
      return (this.loadingContainer.remind = '缺失流程key (processDefinitionKey) ,请检查URL是否正确。')
    }
    /** 正常启动流程, 以下代码均为何磊代码,请参考FlowData原版本,该页只做 代码效率、稳定性优化 */
    delete queryData['businessKey']
    delete queryData['processDefinitionKey']
    this.$http.post('/flow-ext/start-process-instance-by-key', queryData, {
      params: {
        processDefinitionKey,
        businessKey
      }
    }).then(response => {
      let {
        processInstanceId,
        taskId,
        formKeyList,
        formModelJsonList,
        taskFormPropertyList,
        businessKey,
        editMode,
        taskDefinitionKey,
        processDefinitionId
      } = response.data
      if (formKeyList.length) { // 存在表单，需要填写表单
        let options = formModelJsonList[0] || {}
        /** end start  */
        // 根据流程表单元素的属性改变现实表单的属性（如：只读等）
        // ProcessingFormSetting(options.column, taskFormPropertyList)

        let viewFormData = {
          options,
          pageKey: 'DO',
          modelData: {
            processInstanceId,
            taskId,
            businessKey
          },
          keyInfo: {
            processInstanceId,
            taskId,
            businessKey,
            formId: formKeyList[0]
          }
        }

        // 回调函数
        let successCallback = () => {
          this.viewFormData.options = viewFormData.options
          this.viewFormData.modelData = viewFormData.modelData
          this.viewFormData.keyInfo = viewFormData.keyInfo
          this.viewFormData.editMode = editMode
          this.viewFormData.taskDefinitionKey = taskDefinitionKey
          this.viewFormData.processDefinitionId = processDefinitionId
          this.viewFormData.taskFormPropertyList = taskFormPropertyList
          this.loadingContainer.remind = ''
          this.$nextTick(() => { this.$refs.viewForm.Initialize() })
          HandleForm.bind(this, viewFormData.options.column, taskFormPropertyList)()
          if (viewFormData.options.group) {
            viewFormData.options.group.forEach(groupItem => {
              HandleForm.bind(this, groupItem.column, taskFormPropertyList)()
            })
          }
          // bindEvent.bind(this)()
        }
        if (businessKey) {
          this.$http.get('/form-instance/select', {
            params: {
              'dataId': businessKey,
              'formId': formModelJsonList[0].formId,
              'procDefId': processDefinitionId
            }
          }).then(response => {
            viewFormData.modelData = Object.assign(viewFormData.modelData, response.data)
            successCallback()
          }).catch(error => {
            this.loadingContainer.remind = error.msg || error.message
            throw error
          })
        } else {
          successCallback()
        }
      }
    }).catch(error => {
      this.loadingContainer.remind = error.msg || error.message
      throw error
    })
  }
}
</script>

<style lang='scss' scoped>
.loadingContainer {
  width: 500px;
  margin: 0 auto;
  padding: 5px 0;
  color: rgb(59, 156, 217);
  text-align: center;
  font-weight: 600;
  &_icon {
    font-size: 25px;
    &_error {
      color: red;
    }
  }
  &_remind {
    p {
      margin: 0;
      width: 100%;
    }
  }
}
</style>
